import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ActionResponse } from 'src/app/models/action-response';
import * as fromModifyAssetTypeWizard from './reducer';
import { State } from './state';

export const selectModifyTypeWizardState = createFeatureSelector<State>(fromModifyAssetTypeWizard.modifyTypeWizardFeatureKey);

export const selectBulkSearchStep = createSelector(selectModifyTypeWizardState, (state: State): any[] => state.bulkSearchStep);

export const selectModifyAssetTypeState = createSelector(selectModifyTypeWizardState, (state: State): ActionResponse => state.response);

export const selectErrorMessage = createSelector(selectModifyTypeWizardState, (state: State): string => state.errorMessage);
